// extracted by mini-css-extract-plugin
export default {"container":"InviteInfoRow_container__+vsT+","icon":"InviteInfoRow_icon__+Y6Pu","content":"InviteInfoRow_content__rgs1v","title":"InviteInfoRow_title__Z9S1d"};